<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" title="Retourner">
          <v-icon>mdi mdi-arrow-left</v-icon> Menu
        </v-btn>
      </div>
      
      <v-card elevation="0" class="mt-4">
        <v-data-table
          :headers="headers"
          :items="logs_transactions"
          :search="search"
          sort-by="label"
          class="elevation-1"
          :loading="loadings.classes"
          loading-text="Chargement en cours...">
          <template v-slot:item._date="{item}">
            {{ getformatDate(item._createdAt) }}
          </template>
          <template v-slot:item._amount="{item}">
            {{ item._amount }} FCFA
          </template>
          <template v-slot:item._receipt="{item}">
            <a :href="image_base_link+item._receipt" target="_blank">
              <v-img
              :src="image_base_link+item._receipt"
              :lazy-src="image_base_link+item._receipt"
                max-width="40"
                max-height="40"
                >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                  >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
              </v-img>
            </a>
          </template>
          <template v-slot:item._status="{item}">
            <v-chip :color="item._status ? 'green' : 'red'" text-color="white">
              {{ item._status ? 'Succès' : 'Paiement non effectué' }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu rounded="b-xl">
              <template v-slot:activator="{ attrs, on }">
                <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
              </template>
              <v-list>
                <v-list-item
                  v-for="(action_item, index) in actions_items"
                  :key="index"
                  @click="editItemAction(item,index)">
                  <v-list-item-icon>
                    <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="action_item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          
          <template v-slot:top>
            <v-row style="background: #f8f8f8;">
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="background: #f8f8f8;">
              <v-toolbar flat>
                <v-toolbar-title>Paiements pour {{ payment?._instalment._name.toLowerCase() }} de  {{ payment?._student._firstName }} {{ payment?._student._lastName }} </v-toolbar-title>
                <v-spacer/> 
                <v-dialog v-model="dialogCustomer" max-width="700px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="secondary" dark class="mb-2" v-bind="attrs" v-on="on">
                      Ajouter un paiement
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-form ref="clientForm" v-model="clientFormIsValid">
                        <v-container>
                          <h3 class="pb-5 pt-5">Ajouter un log de paiement</h3>
                          <v-row>
                            <v-col lg="6" sm="12">
                              <label for="">Référence</label>

                              <v-text-field
                                v-model="paymentLogToSave._reference"
                                :rules="requiredRules"
                                label="Référence"
                                solo
                              ></v-text-field>
                            </v-col>

                            <v-col v-if="!editingCustomer" lg="6" sm="12"> 
                              <label>Bordereau </label>
                              <v-file-input v-model="file"  accept="image/png, image/jpeg" ref="files" :rules="fileRules" solo placeholder="Téléversez le bordereau du paiement" label="Téléversez le bordereau du paiement" prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                  <v-chip small  label  color="primary">
                                    {{ text }}
                                  </v-chip>
                                </template>
                              </v-file-input>
                            </v-col>

                            <v-col lg="6" sm="12">
                              <label for="">Montant</label>
                              <v-text-field
                                v-model="paymentLogToSave._amount"
                                :rules="[...requiredRules, amountRule]"
                                label="Montant"
                                type="number"
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-alert type="info" border="left" colored-border color="primary">
                                <strong>Montant total à payer:</strong> {{ payment_amount }} FCFA
                              </v-alert>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="dark" @click="dialogCustomer = false, editingCustomer = false">
                        Annuler
                      </v-btn>
                      <v-btn
                        v-if="!editingCustomer"
                        :loading="loadings.fee_saving"
                        color="primary"
                        :disabled="!paymentLogToSave._reference || !paymentLogToSave._amount"
                        @click="saveAcademicYear()"
                      >
                        Enregistrer
                      </v-btn>
                      <v-btn
                        v-if="editingCustomer"
                        :loading="loadings.fee_saving"
                        :disabled="!paymentLogToSave._reference || !paymentLogToSave._amount"
                        color="primary"
                        @click="updateFee()"
                      >
                        Mettre à jour
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import {env} from '../../../env'
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
  },
  data() {
    return {
      // Only keep necessary data properties
      loadings: {
        classes: false,
        fee_saving: false
      },
      image_base_link: env.image_base_url,
      fileRules: [
        v => !!v ||  this.$t('file_required'),
      ],
      pickdateprogram: false,
      pickdateprogramEnd: false,
      logs_transactions: [],
      search: '',
      dialogCustomer: false,
      file: null,
      paymentLogToSave: {
        _student: '',
        _payment: '',
        _reference: '',
        _status: true, // Set status to true by default
        _receipt: '',
        _amount: '',
      },
      headers: [
        {text: 'Référence', value: '_reference'},
        {text: 'Bordereau', value: '_receipt'},
        {text: 'Date', value: '_date'},
        {text: 'Montant', value: '_amount'},
        {text: 'Statut', value: '_status'},
        // {text: '', value: 'actions'},
      ],
      editingCustomer: false,
      actions_items: [
        {title: "Modifier", avatar: 'mdi-pencil'},
        {title: "Supprimer", avatar: 'mdi-delete'},
      ],
      requiredRules: [
        v => !!v || 'Ce champ est requis',
      ],
      payment: null,
      payment_amount: 0,
      amountRule: v => {
        const totalAmount = this.logs_transactions.reduce((sum, log) => sum + log._amount, 0) + parseFloat(v || 0);
        return totalAmount <= this.payment_amount || `Le montant ne peut pas dépasser ${this.payment_amount - this.logs_transactions.reduce((sum, log) => sum + log._amount, 0)} FCFA`;
      }
    }
  },
  computed: {
    ...mapState('countries/', ['countries']),
  },
  mounted() {
    this.initialize();
  },
  created() {
    this.checkisDashboard();
  },
  methods: {
    getformatDate(value) {
      if (value) {
        return Intl.DateTimeFormat('fr-FR', {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
        }).format(new Date(value));
      }
    },
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.editLog(item);
          break;
        case 1:
          this.deleteLog(item);
          break;
      }
    },
    async initialize() {
      if (this.$store.getters.marchand) {
        this.getAllPaymentLogs()
        this.getPayment()
      }
    },
    checkisDashboard() {
        this.$emit('checkisDashboard', true);
    },
    async getAllPaymentLogs() {
      this.loadings.classes = true;
      const response = await client({
        method: 'get',
        url: `/school-payments/transactions/student-payments/payment/`+this.$route.params.payment_id
      })
      .then(resp => resp.data)
      .catch(() => ({ error: "true" }))
      
      this.loadings.classes = false;
      if (!response.error) {
        this.logs_transactions = response;
      }    
    },

    async getPayment() {
      const response = await client({
        method: 'get',
        url: `/school-payments/student-payments/`+this.$route.params.payment_id
      })
      .then(resp => resp.data)
      .catch(() => ({ error: "true" }))

      this.payment = response;
      this.payment_amount = response._amount; // Assuming the payment amount is stored in _amount
    },
    async saveAcademicYear() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        this.paymentLogToSave._student = this.payment._student._id
        this.paymentLogToSave._payment = this.payment._id

        let data = new FormData();
        data.append("_student", this.paymentLogToSave._student);
        data.append("_payment", this.paymentLogToSave._payment);
        data.append("_reference", this.paymentLogToSave._reference);
        data.append("_status", this.paymentLogToSave._status);
        data.append("_receipt", this.file);
        data.append("_amount", this.paymentLogToSave._amount);

        const response = await client({
          method: 'post',
          url: `/school-payments/transactions/student-payments/`,
          data: data
        })
        .then(resp => resp.data)
        .catch(() => ({ error: "true" }))
        
        this.loadings.fee_saving = false;
        this.dialogCustomer = false;
        this.getAllPaymentLogs()
        this.toast(response.type, response.message)
      }
    },
    async updateFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        const response = await client({
          method: 'PUT',
          url: `/school-payments/transactions/student-payments/${this.id}`,
          data: this.paymentLogToSave
        })
        .then(resp => resp.data)
        .catch(() => ({ error: "true" }))
        
        this.loadings.fee_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllPaymentLogs()
        this.toast(response.type, response.message)
      }
    },
    editLog(item) {
      this.editingCustomer = true;
      this.dialogCustomer = true;
      this.paymentLogToSave = {...item};
      this.id = item._id;
    },
    deleteLog(item) {
      Swal.fire({
        icon: 'warning',
        text: this.$t('delete_warning'),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: 'delete',
              url: `/school-payments/transactions/student-payments/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: 'success',
              text: "Suppression réussie",
              confirmButtonText: "Ok",
              confirmButtonColor: "#29B3A6"
            });
            await this.getAllPaymentLogs()
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: 'error',
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              confirmButtonColor: "#29B3A6"
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
    },
  },
}
</script>